module.exports = __webpack_public_path__ + "static/media/image.952e0fb3.jpg";